import React from "react";

import { styled } from "@mui/material";

import { useProgressBarContext } from "../../../../ProgressBarView/context/ProgressBarContext";

export const SecondaryText = () => {
  const { state } = useProgressBarContext();
  const message = state.nextBreakpoint
    ? state.completedBreakpoint?.completeText
    : undefined;

  return (
    <Container className="ig-dp-row-3">
      <Message className="ig-dp-message">
        <span dangerouslySetInnerHTML={{ __html: message || "&nbsp;" }} />
      </Message>
    </Container>
  );
};

const Container = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "center",
});

const Message = styled("div")({
  fontWeight: "bold",
  color: "black",
  textAlign: "center",
  width: "100%",
  "& p": {
    margin: 0,
  },
});
